import { useEffect, useState } from 'react';
import { FormControl, LinearProgress, Select, MenuItem, Grid, SelectChangeEvent } from '@mui/material';
import { useField } from '@unform/core';
import { ParceirosServiceAPI } from '../../../shared/services/api/parceiro/ParceirosService';
import { useAuth } from '../../../shared/contexts';
import { IPartner } from '../../../shared/types/types';

interface IPartnerSelectProps {
  isExternalLoading?: boolean;
  isDisable?: boolean; // Novo parâmetro para controlar se o campo deve ser desabilitado
}

export const PartnerSelect: React.FC<IPartnerSelectProps> = ({ isExternalLoading = false, isDisable = false }) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField('customer');
  const { getUser } = useAuth();

  const [partners, setPartners] = useState<IPartner[]>([]);
  const [selectedPartner, setSelectedPartner] = useState<string | undefined>(defaultValue);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => partners.find((partner) => partner.id === selectedPartner),
      setValue: (_, newSelectedPartner) => {
        setSelectedPartner(newSelectedPartner?.id || undefined);
      },
    });
  }, [registerField, fieldName, partners, selectedPartner]);

  useEffect(() => {
    setIsLoading(true);
    ParceirosServiceAPI.getPartners(getUser())
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          console.error(result.message);
        } else {
          setPartners(result.data); // Certifique-se de que result.data é um array de IPartner
        }
      });
  }, [getUser]);

  const handlePartnerChange = (event: SelectChangeEvent<string>) => {
    clearError();
    setSelectedPartner(event.target.value);
  };

  return (
    <FormControl component="fieldset" error={!!error} disabled={isExternalLoading || isLoading || isDisable} fullWidth>
      {isLoading && (
        <Grid item>
          <LinearProgress variant="indeterminate" />
        </Grid>
      )}

      <Select
        value={selectedPartner || ""}
        onChange={handlePartnerChange}
        displayEmpty
        fullWidth
        style={{ marginTop: 16 }}
      >
        <MenuItem value="" disabled>
          Escolha um parceiro
        </MenuItem>
        {partners.map((partner) => (
          <MenuItem key={partner.id} value={partner.id}>
            {partner.nome_customer}
          </MenuItem>
        ))}
      </Select>

      {!!error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
    </FormControl>
  );
};
